import { render, staticRenderFns } from "./ModalPagosUniversidadesAgrupados.vue?vue&type=template&id=7eea6522"
import script from "./ModalPagosUniversidadesAgrupados.vue?vue&type=script&lang=js"
export * from "./ModalPagosUniversidadesAgrupados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports